import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Grid, GridItem } from '@chakra-ui/react';
const CompositionHeaderFC = () => {
    return (_jsxs(Grid, { gap: "4px", p: "2px 0 6px 0", alignItems: "center", borderBottom: "1px solid", borderColor: "border", templateColumns: "176px 1fr", children: [_jsx(GridItem, { p: "0 0 0 2px", children: "\u041F\u0440\u043E\u0431\u044B" }), _jsx(GridItem, { p: "0 0 0 2px", children: "\u0420\u0430\u0441\u0445\u043E\u0434" })] }));
};
export const CompositionHeader = memo(CompositionHeaderFC);
//# sourceMappingURL=CompositionHeader.js.map